import { api } from "../client";
import { TaskChangelog } from "../schema/TaskChangelog";
import { Config } from "../types";

type ApiRequestConfig = Config<TaskChangelog[]>;

export const getTaskChangelog = async (
  taskId: number,
  config?: ApiRequestConfig
) => {
  return api.get<TaskChangelog[]>(`tasks/${taskId}/task_histories`, config);
};
